<template>
	<div class="view-container">
		<modal :showDialog="(activeModal == 'ADD_TICKET')" @close="closeModal" :title="$t('AddTicket')">
			<ticket-modal :system-id="systemId" @saved="closeModal"/>
		</modal>
		<div class="max-grid tickets-layout" :class="{ 'tickets-layout--mobile': isMobile }">
			<!-- v-show zamiast v-if: na telefonie grid chowa się pod czatem, ale zachowuje filtry i stronę. -->
			<div v-show="!isMobile || selectedTicket == null" class="tickets-layout__grid">
				<ejs-grid ref="grid" height="100%" width="100%" :toolbar="toolbar" :toolbarClick="toolbarClick" :selectionSettings="selectionOptions" :allowTextWrap="false" :dataBound="dataBound" :dataSource="tickets" :allowPaging="true" :pageSettings="pageSettings" :allowFiltering="true" :filterSettings="filterOptions" :allowSorting="true" :allowMultiSorting='true' :sortSettings="sortSettings" :allowPdfExport='true' :allowCsvExport='true' :allowExcelExport='true' :showBusyIndicator="true" :rowDataBound="rowDataBound" :rowSelected="selectionChanged" >
					<e-columns>
						<e-column field="id" :isPrimaryKey="true" :visible="false"></e-column>
						<e-column field="lastMessageDate" :headerText="$t('LastMessage')" width="170" textAlign="Left" :customAttributes="customAttributes" type="dateTime" :format="dateTimeFormatOptions"></e-column>
						<e-column field="subject" :headerText="$t('Subject')" :template="TextTemplate" width="320" minWidth="200" textAlign="Left" :customAttributes="customAttributes"></e-column>
						<e-column field="statusLabel" :headerText="$t('Status')" width="150" textAlign="Left" :customAttributes="customAttributes"></e-column>
						<e-column field="assigneeName" :headerText="$t('AssigneeName')" width="200" textAlign="Left" :customAttributes="customAttributes"></e-column>
						<e-column field="lastMessageFrom" :headerText="$t('LastMessageFrom')" width="200" textAlign="Left" :customAttributes="customAttributes"></e-column>
						<e-column field="createDate" :headerText="$t('CreateDate')" width="170" textAlign="Left" :customAttributes="customAttributes" type="dateTime" :format="dateTimeFormatOptions"></e-column>
					</e-columns>
				</ejs-grid>
			</div>
			<div v-if="!isMobile || selectedTicket != null" class="messages-area tickets-layout__chat">
				<ticket-chat v-if="selectedTicket != null" :ticket="selectedTicket" :show-back="isMobile" @read="markRead" @changed="getData" @back="clearSelection"/>
				<div v-else class="messages-area__empty">{{ $t('SelectTicket') }}</div>
			</div>
		</div>
	</div>
</template>

<script>
'use strict'

import { getSystemTickets } from "../../api/api";

import ProbablyOverflowingTextCell from '../../components/Systems/ProbablyOverflowingTextCell'
import TicketModal from "../../components/Systems/Tickets/TicketModal.vue";
import TicketChat from "../../components/Systems/Tickets/TicketChat.vue";
import { parseUtc, STATUS_KEYS } from "../../components/Systems/Tickets/ticketChat";
import Modal from '@/components/Modal.vue';

import { Sort, Page, Filter, Toolbar, Search, CommandColumn } from '@syncfusion/ej2-vue-grids';

export default {
	props: {
		systemName: {
			required: false,
			type: String
		},
		systemId: {
			required: false,
			type: String
		}
	},
	provide: {
		grid: [Sort, Page, Filter, Toolbar, Search, CommandColumn],
	},
	components: {
		ProbablyOverflowingTextCell,
		Modal,
		TicketModal,
		TicketChat
	},
	data() {
		return {
			// Creator, CreateDate, AssigneeName, SystemName, Status, Subject, Content, MessagesCount, IsRead, LastMessageDate
			tickets: [],
			mode: 'Active',
			activeModal: 'NONE',
			selectedTicket: null,

			customAttributes: { class: 'customcss' },
			dateTimeFormatOptions: { format: 'yyyy-MM-dd HH:mm', type: 'dateTime' },
			pageSettings: { pageSize: 100, pageSizes: [10, 25, 50, 100] },
			sortSettings: { columns: [{ field: 'lastMessageDate', direction: 'Descending' }] },
			filterOptions: {
				type: "Menu",
			},
			selectionOptions: {
				type: "Single"
			},

			TextTemplate: function () {
				return {
					template: {
						extends: ProbablyOverflowingTextCell,
					},
				};
			},
		}
	},
	computed: {
		isMobile() {
			return this.$store.getters.isMobile
		},
		toolbar() {
			return [
				{ text: this.$t('AddTicket'), tooltipText: this.$t('AddTicket'), prefixIcon: 'e-add', id: 'add-ticket', align: 'Left' },
				{ text: this.$t(this.mode == 'Active' ? 'ShowAllTickets' : 'ShowActiveTickets'), id: 'toggle-mode', align: 'Left' },
				{ text: this.$t('ClearFilter'), id: 'clear-filters', prefixIcon: 'e-cancel', align: 'Left', },
				'Search',
			]
		}
	},
	methods: {
		async getData() {
			var response = await getSystemTickets(this.systemId, this.mode);

			this.tickets = response.map(t => ({
				...t,
				// Daty z API są w UTC bez strefy — bez przeliczenia grid pokazywał je przesunięte o offset.
				createDate: parseUtc(t.createDate),
				lastMessageDate: parseUtc(t.lastMessageDate || t.createDate),
				statusLabel: STATUS_KEYS[t.status] ? this.$t(STATUS_KEYS[t.status]) : ''
			}));

			// Zaznaczone zgłoszenie po przeładowaniu (np. po zamknięciu) podmieniamy na świeży wiersz.
			// Jeśli wypadło z filtra „Aktywne”, czat zostaje otwarty ze stanem „zamknięte”.
			if (this.selectedTicket != null) {
				this.selectedTicket = this.tickets.find(t => t.id == this.selectedTicket.id) || this.selectedTicket;
			}
		},
		toolbarClick: function (args) {
			switch (args.item.id) {
				case 'clear-filters':
					this.$refs.grid.clearFiltering();
					break;
				case "add-ticket":
					this.activeModal = "ADD_TICKET";
					break;
				case "toggle-mode":
					this.mode = this.mode == 'Active' ? 'All' : 'Active';
					this.getData();
					break;
			}
		},
		rowDataBound(args) {
			// Klasa zamiast stylu inline — inline przebijał nakładkę ciemnego motywu
			// i wiersz zostawał jasny pod jasnym tekstem. Kolor siedzi w theme.css.
			// IsRead z API = wszystkie wiadomości przeczytane, więc wyróżniamy zgłoszenia z nieprzeczytanymi.
			args.row.classList.toggle('unread-ticket', !args.data["isRead"]);
		},
		dataBound: function () {
			// Temat bez autodopasowania: to szablon komórki i autoFit liczył mu szerokość 0.
			this.$refs.grid.autoFitColumns(['lastMessageDate', 'statusLabel', 'assigneeName', 'lastMessageFrom', 'createDate']);

			if (this.selectedTicket != null) {
				const index = this.$refs.grid.getRowIndexByPrimaryKey(this.selectedTicket.id);
				if (index >= 0) this.$refs.grid.selectRow(index);
			}
		},
		selectionChanged() {
            var selection = this.$refs.grid.getSelectedRecords();

            if(selection.length == 0 || selection.length > 1)
                return

			this.selectedTicket = selection[0]
        },
		markRead(ticketId) {
			// Lokalnie, bez przeładowania listy (i bez gubienia przewinięcia/zaznaczenia).
			const ticket = this.tickets.find(t => t.id == ticketId);
			if (ticket) ticket.isRead = true;

			const index = this.$refs.grid.getRowIndexByPrimaryKey(ticketId);
			const row = index >= 0 ? this.$refs.grid.getRowByIndex(index) : null;
			if (row) row.classList.remove('unread-ticket');
		},
		clearSelection() {
			this.selectedTicket = null;
			this.$refs.grid.clearSelection();
		},
		closeModal() {
			this.activeModal = 'NONE';
			this.getData();
		},
	},
	async mounted() {
		await this.getData()
	}
}
</script>

<style>
.tickets-layout {
	flex-direction: row;
	gap: 10px;
}

.tickets-layout__grid {
	flex: 1;
	min-width: 0;
	height: 100%;
}

.tickets-layout__chat {
	flex: 0 0 38%;
	min-width: 360px;
	height: 100%;
	overflow: hidden;
}

.tickets-layout--mobile .tickets-layout__chat {
	flex: 1;
	min-width: 0;
}

.messages-area {
    background: var(--messages-panel-bg);
    border: 1px solid var(--messages-panel-border);
    border-radius: 5px;
}

.messages-area__empty {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;
	color: var(--chat-muted);
}
</style>



// WEBPACK FOOTER //
// src/views/System/SystemFarmerTickets.vue